import { render, staticRenderFns } from "./CRUDViagensPrevistas.vue?vue&type=template&id=792bc15f&"
import script from "./CRUDViagensPrevistas.vue?vue&type=script&lang=js&"
export * from "./CRUDViagensPrevistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports